import Vue from 'vue';
import VueRouter from 'vue-router';
import RootChrome from '@/layouts/RootChrome.vue';
import AppChrome from '@/layouts/AppChrome.vue';
import { createRoutes as createHomepageRoute } from '@/views/Homepage';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Root',
    component: RootChrome,
    children: [
      {
        path: '/',
        name: 'root',
        component: AppChrome,
        children: [
          ...createHomepageRoute(),
        ],
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
